import { render, staticRenderFns } from "./admin-view.vue?vue&type=template&id=c97fca76&"
import script from "./admin-view.vue?vue&type=script&lang=js&"
export * from "./admin-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports